import React from "react";

import { Field, getIn } from "formik";

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Text,
  Flex,
  Textarea,
} from "@chakra-ui/react";

export const CustomTextArea = ({
  fieldName,
  mt,
  label,
  placeholder,
  setIsTextareaFocused,
  maxLength,
  isTextareaFocused,
  isDisabled,
  fontWeightLabel,
  colorLabel,
  fontSizeLabel,
  lineHeightLabel,
}) => {
  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <Flex flexDir="column" position="relative">
          <FormControl
            name={fieldName}
            isInvalid={
              (form.errors[fieldName] && form.touched[fieldName]) ||
              (getIn(form.errors, fieldName) && getIn(form.touched, fieldName))
            }
            id={fieldName}
            mt={mt ? mt : "0px"}
          >
            <FormLabel
              color={colorLabel ? colorLabel : "black"}
              fontWeight={fontWeightLabel ? fontWeightLabel : ""}
              fontSize={fontSizeLabel ? fontSizeLabel : ""}
              lineHeight={lineHeightLabel ? lineHeightLabel : ""}
              htmlFor={fieldName}
            >
              {label}
            </FormLabel>
            <Textarea
              {...field}
              name={fieldName}
              id={fieldName}
              backgroundColor="#fff"
              autoComplete="off"
              border="1px solid #D7D8DE"
              placeholder={placeholder}
              isDisabled={isDisabled && isDisabled}
              onFocus={() => setIsTextareaFocused(true)}
              onBlur={() => setIsTextareaFocused(false)}
              maxLength={maxLength}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= maxLength) {
                  form.setFieldValue(`${fieldName}`, value);
                }
              }}
            />
            <Text
              zIndex={isTextareaFocused ? 1 : 0}
              fontSize="sm"
              position="absolute"
              bottom="5px"
              right="15px"
              color={field?.value?.length === maxLength ? "red" : "gray"}
            >
              {field?.value?.length || 0}/{`${maxLength}`}
            </Text>
            <FormErrorMessage>
              {form.errors[fieldName] ||
                getIn(form.errors, fieldName) ||
                getIn(form.errors, fieldName)}
            </FormErrorMessage>
          </FormControl>
        </Flex>
      )}
    </Field>
  );
};
